export const BRAND = {
  name: "Melo Vistos & Passaportes Ltda",
  trade: "MELO VISTOS",
  cnpj: "48.886.963/0001-60",
  phone: "(11) 97799-7393",
  phoneRaw: "5511977997393",
  email: "melovistos@gmail.com",
  instagram: "@melovistos",
  instagramUrl: "https://instagram.com/melovistos",
  facebookUrl: "https://facebook.com/melovistos",
  logo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_assessoria-vistos/artifacts/41ad7cb094566cb4_WhatsApp%20Image%202026-10-16%20at%2016.35.42.jpeg",
};

export const waLink = (msg) =>
  `https://wa.me/${BRAND.phoneRaw}?text=${encodeURIComponent(msg)}`;

export const WA_DEFAULT = waLink(
  "Olá, gostaria de informações sobre assessoria de visto com a Melo Vistos."
);

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1655722724447-2d2a3071e7f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxwYXNzcG9ydCUyMHRyYXZlbCUyMGJvYXJkaW5nJTIwbHV4dXJ5fGVufDB8fHx8MTc5MjE3OTYyNXww&ixlib=rb-4.1.0&q=85";

export const MARQUEE_ITEMS = [
  "ESTADOS UNIDOS (B1/B2)",
  "CIDADANIA ITALIANA (CONSULAR & JUDICIAL)",
  "CANADÁ (eTA & V-1)",
  "MÉXICO (CONSULAR)",
  "JAPÃO (eVISA)",
  "CHINA (CANTON FAIR)",
  "AUSTRÁLIA (SUBCLASS 600)",
  "EMISSÃO DE PASSAPORTE PF",
  "SIMULAÇÃO DE ENTREVISTA CONSULAR",
];

export const DESTINATIONS = [
  {
    id: "usa",
    country: "Estados Unidos",
    region: "americas",
    category: "B1/B2 Turismo & Negócios, F1 Estudante",
    image:
      "https://images.unsplash.com/photo-1590560876538-1d4eef066e28?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxuZXclMjB5b3JrJTIwc3RhdHVlJTIwb2YlMjBsaWJlcnR5JTIwbmlnaHR8ZW58MHx8fHwxNzkyMTc5NjI1fDA&ixlib=rb-4.1.0&q=85",
    tag: "Mais Solicitado",
    forte: true,
    rate: "98.4%",
    time: "Agendamento emergencial disponível",
    badge: "DS-160 & CASV/Consulado",
    featured: true,
    checklist: [
      "Preenchimento técnico do formulário DS-160",
      "Agendamento CASV e Consulado (vagas antecipadas)",
      "Treinamento individual para a entrevista consular",
      "Revisão estratégica de vínculos socioeconômicos",
    ],
  },
  {
    id: "italia",
    country: "Cidadania Italiana",
    region: "global",
    category: "Via Consular no Brasil & Via Judicial na Itália",
    image:
      "https://images.unsplash.com/photo-1753901150661-ace67d229577?auto=format&fit=crop&w=1600&q=80",
    tag: "Nossa Especialidade",
    forte: true,
    rate: "2",
    rateUnit: "VIAS DE PROCESSO",
    time: "Consular & Judicial",
    badge: "Iure Sanguinis",
    featured: true,
    checklist: [
      "Análise genealógica e de elegibilidade conforme as regras vigentes",
      "Via consular: processo administrativo junto ao consulado italiano no Brasil",
      "Via judicial: ação na Itália contra as filas consulares excessivas",
      "Certidões, retificações, traduções juramentadas e apostilamento completos",
    ],
  },
  {
    id: "canada",
    country: "Canadá",
    region: "americas",
    category: "V-1 Turismo, eTA eletrônico & Estudos",
    image:
      "https://images.unsplash.com/photo-1543962226-818f4301073f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHx0b3JvbnRvJTIwc2t5bGluZSUyMG5pZ2h0fGVufDB8fHx8MTc5MjE4MDIxN3ww&ixlib=rb-4.1.0&q=85",
    tag: "eTA & Visto V-1",
    rate: "99.1%",
    time: "Biometria rápida",
    badge: "Canadá Expresso",
    checklist: [
      "Emissão do eTA ou visto de visitante V-1",
      "Preenchimento IMM5257 sem inconsistências",
      "Comprovação financeira guiada",
      "Agendamento de biometria no VFS",
    ],
  },
  {
    id: "japan",
    country: "Japão",
    region: "asia",
    category: "Turismo, Visita a Familiares & Negócios",
    image:
      "https://images.unsplash.com/photo-1705073021025-597e7f9f5488?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHx0b2t5byUyMG5pZ2h0JTIwc2t5bGluZSUyMGphcGFufGVufDB8fHx8MTc5MjE3OTYyNXww&ixlib=rb-4.1.0&q=85",
    tag: "eVisa & Consular",
    rate: "99.7%",
    time: "Processamento consular ágil",
    badge: "Itinerário Completo",
    checklist: [
      "Montagem de itinerário de viagem completo",
      "Formulário consular japonês revisado",
      "Documentação de vínculo e renda",
      "Protocolo junto ao Consulado do Japão",
    ],
  },
  {
    id: "mexico",
    country: "México",
    region: "americas",
    category: "Autorização Eletrônica & Visto Consular",
    image:
      "https://images.unsplash.com/photo-1512813195386-6cf811ad3542?crop=entropy&cs=srgb&fm=jpg&q=85",
    tag: "Consular & SAE",
    rate: "97.8%",
    time: "Agendamento MEXITEL",
    badge: "Assessoria Documental",
    checklist: [
      "Análise de elegibilidade para isenção",
      "Agendamento no sistema MEXITEL",
      "Preparação documental completa",
      "Orientação para entrevista consular",
    ],
  },
  {
    id: "china",
    country: "China",
    region: "asia",
    category: "L Turismo, M Negócios & Feiras Internacionais",
    image:
      "https://images.unsplash.com/photo-1508804185872-d7badad00f7d?crop=entropy&cs=srgb&fm=jpg&q=85",
    tag: "Canton Fair & Negócios",
    rate: "98.9%",
    time: "Formulário COVA",
    badge: "Carta Convite & Suporte",
    checklist: [
      "Preenchimento do formulário COVA",
      "Suporte para carta-convite comercial",
      "Roteiro para feiras (Canton Fair e outras)",
      "Protocolo no CVASC / Embaixada",
    ],
  },
  {
    id: "australia",
    country: "Austrália",
    region: "asia",
    category: "Subclass 600 Turismo, Negócios & Estudos",
    image:
      "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?crop=entropy&cs=srgb&fm=jpg&q=85",
    tag: "ImmiAccount 100% Online",
    rate: "98.2%",
    time: "Comprovação financeira guiada",
    badge: "Subclass 600",
    checklist: [
      "Criação e gestão da ImmiAccount",
      "Aplicação online Subclass 600",
      "Tradução e upload documental",
      "Acompanhamento até a decisão",
    ],
  },
  {
    id: "others",
    country: "Reino Unido, Europa & Mais",
    region: "global",
    category: "Passaportes Brasileiros, ETIAS & Vistos Globais",
    image:
      "https://images.unsplash.com/photo-1487637419635-a2a471ff5c7b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHw0fHxwYXNzcG9ydCUyMHRyYXZlbCUyMGJvYXJkaW5nJTIwbHV4dXJ5fGVufDB8fHx8MTc5MjE3OTYyNXww&ixlib=rb-4.1.0&q=85",
    tag: "Assessoria Global",
    rate: "99.0%",
    time: "Polícia Federal & Embaixadas",
    badge: "Passaporte & Vistos",
    wide: true,
    checklist: [
      "Emissão e renovação de passaporte na PF",
      "Agendamento, GRU e documentação completa",
      "ETIAS e autorizações europeias",
      "Vistos para Reino Unido e demais países",
    ],
  },
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Análise Estratégica de Perfil",
    desc: "Avaliamos seus vínculos socioeconômicos no Brasil, histórico de viagens e identificamos o visto ideal para mitigar qualquer risco de recusa.",
  },
  {
    step: "02",
    title: "Preenchimento & Montagem Rigorosa",
    desc: "Preenchimento técnico e minucioso de formulários consulares oficiais (DS-160, IMM5257, COVA, etc.) sem brechas ou contradições.",
  },
  {
    step: "03",
    title: "Agendamento & Simulação de Entrevista",
    desc: "Monitoramento constante das melhores datas consulares e preparação psicológica e documental simulando as perguntas reais do cônsul.",
  },
  {
    step: "04",
    title: "Emissão & Passaporte em Mãos",
    desc: "Acompanhamento até a chancela do visto no passaporte e entrega de orientações pré-embarque para sua alfândega e imigração.",
  },
];

export const TESTIMONIALS = [
  {
    author: "Dr. Guilherme Sampaio",
    destination: "EUA (B1/B2)",
    city: "São Paulo - SP",
    quote:
      "Tinha muito receio da entrevista após um visto negado anos atrás. A equipe da Melo Vistos refez toda a minha estratégia, treinou as respostas e fomos aprovados em 3 minutos!",
    rating: 5,
  },
  {
    author: "Mariana & Carlos Becker",
    destination: "Canadá + Japão",
    city: "Curitiba - PR",
    quote:
      "Fizemos o processo da família toda para o Canadá e depois o visto do Japão. Sem estresse com formulários intermináveis. Assessoria impecável e pontual.",
    rating: 5,
  },
  {
    author: "Renato Junqueira",
    destination: "China (Feira de Negócios)",
    city: "Belo Horizonte - MG",
    quote:
      "A carta-convite e o formulário chinês são complicadíssimos. A Melo Vistos cuidou de tudo com extrema perícia. Recomendo de olhos fechados.",
    rating: 5,
  },
];

export const FAQS = [
  {
    q: "Por que contratar a Melo Vistos em vez de tentar sozinho?",
    a: "Erros em formulários consulares oficiais (como o DS-160 ou COVA) ficam registrados no histórico do solicitante de forma definitiva. Nossa assessoria atua preventivamente, organizando comprovação documental, eliminando inconsistências e preparando você para a postura exata exigida pelo oficial consular.",
  },
  {
    q: "A Melo Vistos garante a aprovação do meu visto?",
    a: "A decisão soberana cabe unicamente ao cônsul e ao órgão de imigração do país de destino. O que a Melo Vistos garante é o mais alto padrão técnico, conformidade total de documentos e treinamento avançado que historicamente eleva nossa taxa de aprovação para 98.4%.",
  },
  {
    q: "Vocês também realizam emissão e renovação de passaporte brasileiro?",
    a: "Sim! Cuidamos de todo o agendamento junto à Polícia Federal, preenchimento da GRU, orientações de documentação exigida e retirada do passaporte nacional.",
  },
  {
    q: "Como funciona o agendamento de urgência ou emergencial?",
    a: "Possuímos sistema de monitoramento de desistências e vagas antecipadas para casos de emergência médica, viagens de negócios inadiáveis ou viagens familiares urgentes.",
  },
  {
    q: "Atendem clientes de fora de São Paulo?",
    a: "Sim! Atendemos brasileiros em todo o território nacional e também cidadãos residentes no exterior através de videoconferência, atendimento digital e envio seguro de documentos.",
  },
];

export const FORM_DESTINATIONS = [
  "Estados Unidos",
  "Cidadania Italiana",
  "Canadá",
  "Japão",
  "México",
  "China",
  "Austrália",
  "Passaporte (Polícia Federal)",
  "Outro destino",
];
